import script from "./PrayerRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayerRequest.vue?vue&type=script&setup=true&lang=js"

import "./PrayerRequest.vue?vue&type=style&index=0&id=25fb125e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25fb125e"]])

export default __exports__